import React, {useEffect} from 'react';

import {
    sendDesktopAnalyticsEvent,
    sendDesktopAnalyticsPerSession,
} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {ShadowCard} from '@optimaxdev/design-system';
import {Icon, Approve, GlassesUsa} from '@optimaxdev/icons';
import {useInView} from 'react-intersection-observer';

import {Price} from 'components/price/price';
import {TYP_INFO_BLOCK} from 'constants/analytics/events/typ';

import * as RewardsLogo from '../assets/icons/rewards.svg';

import s from './successPageRewardsBannerV2.scss';

/**
 * TYP rewards banner
 */
export const SuccessPageRewardsBannerV2 = () => {
    const {inView, ref} = useInView({
        triggerOnce: true,
    });

    useEffect(() => {
        if (inView) {
            sendDesktopAnalyticsPerSession({
                event: TYP_INFO_BLOCK,
                isInteraction: false,
                label: {
                    blockName: 'Rewards',
                    label: 'Showed',
                },
            });
        }
    }, [inView]);

    const sendAnalytic = () => {
        sendDesktopAnalyticsEvent(
            TYP_INFO_BLOCK,
            {
                blockName: 'Rewards',
                label: 'CTA - Clicked',
            },
            true,
        );
    };
    return (
        <div className={s.rewardsBanner} ref={ref}>
            <ShadowCard className={s.card} corner={5} saturate={1}>
                <div className={s.header}>
                    <Icon className={s.logo} icon={GlassesUsa} width="113px" />
                    <Icon icon={RewardsLogo} width="125px" />
                </div>
                <p className={s.text}>
                    Congrats! You&apos;re one click away from VIP status. Unlock exclusive perks,
                    big discounts, and more.
                </p>
                <ul className={s.list}>
                    <li className={s.item}>
                        <Icon
                            className={s.approveIcon}
                            icon={Approve}
                            strokeWidth={1.5}
                            width="16px"
                        />
                        <b>
                            <Price>15</Price> off your next purchase
                        </b>
                    </li>
                    <li className={s.item}>
                        <Icon
                            className={s.approveIcon}
                            icon={Approve}
                            strokeWidth={1.5}
                            width="16px"
                        />{' '}
                        Free shipping for life
                    </li>
                    <li className={s.item}>
                        <Icon
                            className={s.approveIcon}
                            icon={Approve}
                            strokeWidth={1.5}
                            width="16px"
                        />{' '}
                        Exclusive deals and drops
                    </li>
                </ul>
                <a
                    className={s.link}
                    href="https://www.glassesusa.com/rewards"
                    onClick={sendAnalytic}
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    Join Now for Free!
                </a>
                <p className={s.privacy}>
                    By joining you agree to receive GlassesUSA.com
                    <br />
                    emails and our Terms of Use & Privacy Policy.
                </p>
            </ShadowCard>
        </div>
    );
};
